import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Monaco's automatic layout can trigger this benign browser notice when the page resizes around the
// editor. Nothing is lost, but the development error overlay would report it as a crash.
window.addEventListener("error", (event) => {
  if (event.message?.startsWith("ResizeObserver loop")) event.stopImmediatePropagation();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
